module.exports = __webpack_public_path__ + "static/Q2Answer6_Heights_CaseyHorner-a6c4efaa8933a372ae421917593072bf.jpg";